var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form-input',{ref:"autocomplete",attrs:{"type":_vm.type,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"label":_vm.label,"name":_vm.name,"id":_vm.name,"showResetButton":true},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }